

export const Environment = {
  production: true,
  apiUrl: 'https://idnapis.doh.gov.ae/idnweb',
  provisonedUrl: 'https://ieprod.doh.gov.ae/DOHInt/RestFul/IDN',
  crmUrl:'https://prpcrm.doh.gov.ae/staging/tools/audit/audit_details.aspx?id=',
  integrationURL: 'https://idnapis.doh.gov.ae/idnintegration',

  msalConfig: {
    auth: {
      clientId: '620e26cb-5cd0-4812-b02f-89e15ce7ea5d',
      authority: 'https://login.microsoftonline.com/92e3f433-65c8-460d-9a27-e252a02d1b4f',
      redirectUri: 'https://tableegh.doh.gov.ae/', 
    }
  },
  phpConfig: {
    auth: {
      logoutUri: 'https://abudhabiphp.doh.gov.ae/app'
    }
  },
  apiConfig: {
    scopes: ['openid', 'User.Read'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  },

  uaePassConfig: {
    'url': 'https://id.uaepass.ae/idshub/',
    'redirect_url': 'https://tableegh.doh.gov.ae/', 
    'grant_type': 'authorization_code',
    'content_type': 'multipart/form-data',
    'scope_resident': 'urn:uae:digitalid:profile:general',
    'client_id': 'doh_tableegh_web_prod'
  },
  powerBI:{
    'idn_url':'https://prpcrmpowerbireports.doh.gov.ae/reports/powerbi/NEW%20IDN%20Reports/New%20IDN%20Incident%20Dashboard?rs:Command=Render&rc:Toolbar=false',
    'amr_url': 'https://prpcrmpowerbireports.doh.gov.ae/reports/powerbi/NEW%20IDN%20Reports/AMR%20Dashboard?rs:Command=Render&rc:Toolbar=false',
    'cdd_url': 'https://prpcrmpowerbireports.doh.gov.ae/reports/powerbi/tableegh/CDD%20Dashboard?rs:Command=Render&rc:Toolbar=false',
    'influenza_url': 'https://prpcrmpowerbireports.doh.gov.ae/reports/powerbi/tableegh/cdd%20-%20influenza%20report?rs:Command=Render&rc:Toolbar=false',

  }
};
